const itemNamesSeason1 = `
# -- DUD --
# 1. スペイン #=2
a-0-0 a-0-1

# 2. チリ #=2
a-4-0 a-4-1

# 3. オーストラリア #=2
a-10-0 a-10-1

# 4. ハワイ #=2
a-13-0 a-13-1

# -- WIDE --
# 5. ヨーロッパ #=4
a-1-0 a-1-1 a-1-2 a-1-3

# 6. 北米 #=5
a-11-0 a-11-1 a-11-2 a-12-0 a-12-1

# 7. アフリカ #=5
a-8-0 a-8-1 a-8-2 a-9-0 a-9-1

# 8. オセアニア+アジア #=7
a-2-0 a-2-1 a-2-2 a-2-3 a-3-0 a-3-1 a-3-2

# 9. 南極 #=9
a-14-0 a-14-1 a-14-2 a-15-0 a-15-1 a-15-2 a-16-0 a-16-1 a-16-2

# 10. 南米 #=10
a-5-0 a-5-1 a-5-2 a-5-3 a-6-0 a-6-1 a-6-2 a-7-0 a-7-1 a-7-2
`.replace(/#.*$/mg, '').split(/\s+/).filter((s) => s.length > 0)

import { Vue, Component } from "vue-property-decorator"
import { store } from '@/store';

interface ILevel {
  name: string
  items: Array<{ name: string, active: boolean }>
}

@Component
export default class extends Vue {
  get gc() {
    return store.galaxyCruise
  }

  get levels() {
    const levels: ILevel[] = []
    const names = itemNamesSeason1.slice()
    const doneItems = this.gc.specialityGoodsCount
    let done = 0
    for (const level of this.gc.session!.levels) {
      levels.push({
        name: (level as any)[`${this.$i18n.locale}_name`],
        items: names.splice(0, level.num_goods).map((name, i) => {
          return { name, active: done + i < doneItems }
        }),
      })
      done += level.num_goods
    }
    return levels
  }

  get items() {
    const doneItems = this.gc.specialityGoodsCount
    return itemNamesSeason1.map((name, i) => {
      return { name, active: i < doneItems }
    })
  }
}
